// eslint-disable-next-line import/prefer-default-export
export const getAirports = (state) => state.get('airports').toJS();
